import { format } from "date-fns";

/**
 * Use date-fns formatter as moment js is no longer maintained
 * @param date
 * @param formatString
 * @returns {*}
 */
export const formatDate = (date, formatString = "D/M/YY") =>
  format(date, formatString);
